class IntervalManager {
  private readonly metricIntervals: number[] = [];
  private readonly transactionIntervals: number[] = [];
  private readonly transactionCountIntervals: number[] = [];
  private readonly entityIntervals: number[] = [];

  private readonly alertIntervals: number[] = [];
  private readonly alertCountIntervals: number[] = [];

  public getMetricIntervals() {
    return this.metricIntervals;
  }

  public getTransactionIntervals() {
    return this.transactionIntervals;
  }

  public getEntityIntervals() {
    return this.entityIntervals;
  }

  public clearMetricIntervals() {
    this.metricIntervals.map((interval) => clearInterval(interval));
    while (this.metricIntervals.length > 0) {
      this.metricIntervals.pop();
    }
  }

  public clearTransactionIntervals() {
    this.transactionIntervals.map((interval) => clearInterval(interval));
    while (this.transactionIntervals.length > 0) {
      this.transactionIntervals.pop();
    }
  }

  public clearEntityIntervals() {
    this.entityIntervals.map((interval) => clearInterval(interval));
    while (this.entityIntervals.length > 0) {
      this.entityIntervals.pop();
    }
  }

  public clearTransactionCountIntervals() {
    this.transactionCountIntervals.map((interval) => clearInterval(interval));
    while (this.transactionCountIntervals.length > 0) {
      this.transactionCountIntervals.pop();
    }
  }

  public addMetricInterval(interval: number) {
    this.metricIntervals.push(interval);
  }

  public addTransactionInterval(interval: number) {
    this.transactionIntervals.push(interval);
  }

  public addEntityInterval(interval: number) {
    this.entityIntervals.push(interval);
  }

  public addTransactionCountInterval(interval: number) {
    this.transactionCountIntervals.push(interval);
  }

  public getAlertIntervals() {
    return this.alertIntervals;
  }

  public getAlertCountIntervals() {
    return this.alertCountIntervals;
  }

  public clearAlertIntervals() {
    this.alertIntervals.map((interval) => clearInterval(interval));
    while (this.alertIntervals.length > 0) {
      this.alertIntervals.pop();
    }
  }

  public clearAlertCountIntervals() {
    this.alertCountIntervals.map((interval) => clearInterval(interval));
    while (this.alertCountIntervals.length > 0) {
      this.alertCountIntervals.pop();
    }
  }

  public addAlertInterval(interval: number) {
    this.alertIntervals.push(interval);
  }

  public addAlertCountInterval(interval: number) {
    this.alertCountIntervals.push(interval);
  }
}

export default IntervalManager;
